import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=07ffc5b6&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ffc5b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07ffc5b6')) {
      api.createRecord('07ffc5b6', component.options)
    } else {
      api.reload('07ffc5b6', component.options)
    }
    module.hot.accept("./Contact.vue?vue&type=template&id=07ffc5b6&scoped=true", function () {
      api.rerender('07ffc5b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/crm/Contact.vue"
export default component.exports